export const iconFontAwesomeWeatherIcicles = (
	<i className="fa-solid fa-icicles"></i>
);
